import { mapState } from 'vuex'

/**
 * Possible States of a Username input
 * @type {Readonly<{valid: string, tooShort: string, invalid: string, tooLong: string, notAvailable: string}>}
 */
export const UsernameState = Object.freeze({
  valid: 'USERNAME.VALID',
  invalid: 'USERNAME.INVALID',
  tooShort: 'USERNAME.TO_SHORT',
  tooLong: 'USERNAME.TOO_LONG',
  notAvailable: 'USERNAME.NOT_AVAILABLE',
  forbidden: 'USERNAME.FORBIDDEN'
})

export default {
  data () {
    return {
      /**
       * Current state of the username
       */
      usernameState: UsernameState.valid,
      /**
       * Possible user names that are still available
       */
      usernameSuggestions: [],
    }
  },
  computed: {
    ...mapState(['username']),
    /**
     * Returns true if the username is valid
     * @returns {boolean}
     */
    usernameValid () {
      return this.usernameState === UsernameState.valid
    },
  },
  methods: {
    /**
     * Check if a username is available
     * Sets the username state and loads the username suggestions if username is not available
     * @param username
     * @returns {Promise<any>}
     */
    checkUsername (username) {
      if(username.isEmpty()) {
        this.usernameState = UsernameState.tooShort;
        return new Promise((complete) => {
          complete()
        });
      }

      return this.requestValidateUsername(username)
        .then(() => {
          this.usernameSuggestions = []
          this.usernameState = UsernameState.valid
        })
        .catch(error => {
          this.usernameState = this.getUsernameState(error.body)
          if (this.usernameState === UsernameState.notAvailable) this.loadUsernameSuggestions(username)
        })
    },
    /**
     * Load the username suggestions
     * @param value
     */
    loadUsernameSuggestions (value) {
      this.requestUsernameSuggestions(value)
        .then(response => {
          this.usernameSuggestions = []

          const { usernameForbidden, nicknameSuggestions } = response
          if (usernameForbidden === true) return
          this.usernameSuggestions = nicknameSuggestions
        })
    },
    /**
     * Check the error messages form the api for error codes and get the related username state
     * @param data
     * @returns {*}
     */
    getUsernameState (data) {
      const values = Object.values(data)

      if (values.indexOf('nickname_forbidden') !== -1) return UsernameState.forbidden
      if (values.indexOf('nickname_invalid') !== -1) return UsernameState.invalid
      if (values.indexOf('nickname_too_short') !== -1) return UsernameState.tooShort
      if (values.indexOf('nickname_too_long') !== -1) return UsernameState.tooLong
      if (values.indexOf('nickname_not_available') !== -1) return UsernameState.notAvailable

      return UsernameState.valid
    },
  },
}
